import React, { useEffect } from "react";
import Layout from '../components/layout/Layout';
import { videos } from '../data/videos';

export default function Videos() {
  // Scroll to top when component loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-6xl md:text-8xl font-light mb-6">Videos</h1>
          <p className="text-xl text-gray-600 font-light mb-20">
            Watch my performances, tutorials, and musical journey.
          </p>
          
          <div className="space-y-16">
            {videos.map((video) => (
              <div key={video.id} className="space-y-6">
                {/* Video Title */}
                <h2 className="text-3xl md:text-4xl font-light">
                  {video.title}
                </h2>
                
                {/* YouTube Video Embed */}
                <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                  <iframe
                    className="absolute top-0 left-0 w-full h-full rounded-lg shadow-xl"
                    src={`https://www.youtube.com/embed/${video.youtubeId}`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                
                {/* Video Description */}
                <p className="text-lg text-gray-700 leading-relaxed">
                  {video.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}